<template>
    <div>
        <div id="multi_operation_type" class="bulk-operations">
            <b-checkbox  @change="toggleAll"><span class="text--500">{{filesId.length}}  {{$t('files.base.files')}}</span> {{$t('files.base.selected')}}</b-checkbox>
            <b-button size="-small" variant="-secondary" @click="handleShowPrintFile">{{$t('printers.modal.choosePrinter.print')}}</b-button>
            <b-button size="-small" variant="-primary" @click="handleShowMove">{{$t('files.multiActions.moveToProject')}}</b-button>
            <b-button size="-small" variant="-primary btn--outline" @click="handleShowCopy">{{$t('files.multiActions.copyToProject')}}</b-button>
            <b-button size="-small" variant="-ternary btn--outline" @click="setDeleteFiles"> {{$t('buttons.delete')}}</b-button>
        </div>


        <b-modal v-model="showMove" class="choose-printer" size="lg">
            <template v-slot:modal-title>{$t('files.modal.moveFilesToProject')}}</template>
            <file-list :files="files"></file-list>
            <project-list-select @select="setMoveToProject" :projects="sortedProjects"></project-list-select>
            <template v-slot:modal-footer="{ cancel, ok }">
                <new-project-name @name="setMoveToProjectByName"></new-project-name>
            </template>
        </b-modal>

        <b-modal v-model="showCopy" class="choose-printer" size="lg">
            <template v-slot:modal-title>{$t('files.modal.copyFilesToProject')}}</template>
            <file-list :files="files"></file-list>
            <project-list-select @select="setCopyToProject" :projects="sortedProjects"></project-list-select>
            <template v-slot:modal-footer="{ cancel, ok }">
                <new-project-name @name="setCopyToProjectByName"></new-project-name>
            </template>
        </b-modal>


    </div>
</template>

<script>
    import FileList from '@/components/files/FileList'
    import NewProjectName from '@/components/files/modal/mass/NewProjectName'
    import {mapGetters, mapActions} from 'vuex'
    import ProjectListSelect from "../projects/ProjectListSelect";

    export default {
        name: "FileMassActionButtons",
        props: ['filesId'],
        components: {ProjectListSelect, FileList, NewProjectName},
        data() {
            return {
                showMove: false,
                showCopy: false,
                showPrint: false
            }
        },
        computed: {
            ...mapGetters(['getFilesSelectFull', 'sortedProjects' ]),
            files() {
                return this.getFilesSelectFull(this.filesId);
            }
        },
        methods: {
            ...mapActions(['moveToProject', 'copyToProject', 'deleteFiles', 'removeAllSelectFiles' , 'setAllSelectFiles']),
            toggleAll(checked){

              if(checked){
                this.setAllSelectFiles()
              }else{
                this.removeAllSelectFiles()
              }

            },
            setMoveToProjectByName(name) {
                this.moveToProject({
                    project_name: name,
                    id: this.filesId
                }).then(({data}) => {
                    if (data.result) {
                        this.showMove = false
                        this.removeAllSelectFiles()
                    } else {
                        console.log(data.message)
                    }
                });
            },

            setMoveToProject(projectId) {

                this.moveToProject({
                    project_id: projectId,
                    id: this.filesId
                }).then(({data}) => {
                    if (data.result) {
                        this.showMove = false
                        this.removeAllSelectFiles()
                    } else {
                        console.log(data.message)
                    }
                });
            },

            setCopyToProjectByName(name) {
                this.copyToProject({
                    project_name: name,
                    id: this.filesId
                }).then(({data}) => {
                    if (data.result) {
                        this.showCopy = false
                        this.removeAllSelectFiles()
                    } else {
                        console.log(data.message)
                    }
                });
            },

            setCopyToProject(projectId) {

                this.copyToProject({
                    project_id: projectId,
                    id: this.filesId
                }).then(({data}) => {
                    if (data.result) {
                        this.showCopy = false
                        this.removeAllSelectFiles()
                        console.log(this.filesId)
                    } else {
                        console.log(data.message)
                    }
                });
            },
            setDeleteFiles() {
                this.deleteFiles({id: this.filesId}).then(({data}) => {
                    if (data.result) {
                        this.removeAllSelectFiles()
                    } else {
                        console.log(data.message)
                    }
                });
            },
            handleShowMove() {
                this.showMove = true;
            },
            handleShowCopy() {
                this.showCopy = true;
            },
            handleShowPrintFile() {
                window.vuePrintFile(this.filesId);
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/theme";

    .bulk-operations {
        position: fixed;
        padding: 10px 12px;
        box-shadow: 0 0 24px #00000050;
        bottom: 0;
        z-index: 100;
        margin-left: -38px;
        display: flex;
        align-items: center;
        background: white;
        border-radius: $s-border-radius $s-border-radius 0 0;

        .custom-control-label {
            margin: 2px 18px 0 0;

            &:before, &:after {
                top: 1px;
            }
        }

        .btn {
            margin-left: 24px;
        }
    }
</style>
